import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';

export type RegisterPushTokenRequest = {
  pushToken: string;
  platform: 'android' | 'ios' | 'web' | 'unknown';
  tenantId?: string;
};

export type DeactivatePushTokenRequest = {
  pushToken: string;
  tenantId?: string;
};

export type TestPushRegistrationResponse = {
  success: true;
  forwarded: boolean;
  warning?: string;
  hasActiveToken: boolean;
};

class PushService {
  async registerToken(payload: RegisterPushTokenRequest): Promise<{ success: true; forwarded: boolean; warning?: string }> {
    try {
      const response = await authenticatedInstance.post<{ success: true; forwarded: boolean; warning?: string }>('/push/token', payload);
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'רישום טוקן פוש נכשל'));
    }
  }

  async deactivateToken(payload: DeactivatePushTokenRequest): Promise<void> {
    try {
      await authenticatedInstance.post('/push/token/deactivate', payload);
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'ביטול טוקן פוש נכשל'));
    }
  }

  async testRegistration(input?: { tenantId?: string; employeeSession?: string | null }): Promise<TestPushRegistrationResponse> {
    try {
      if (input?.tenantId && input?.employeeSession) {
        const response = await authenticatedInstance.post<TestPushRegistrationResponse>(
          `/push/test/tenant/${encodeURIComponent(input.tenantId)}`,
          {},
          {
            headers: {
              'x-employee-session': input.employeeSession,
            },
          },
        );
        return response.data;
      }

      const response = await authenticatedInstance.post<TestPushRegistrationResponse>('/push/test');
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'בדיקת פוש נכשלה'));
    }
  }
}

export const pushService = new PushService();
